import { gql } from '@apollo/client';

export const ALL_JOBS_QUERY = gql`
  query AllJobs($domainId: Int!) {
    allJobs(condition: { domainId: $domainId }, orderBy: CREATED_AT_DESC) {
      nodes {
        id
        name
        description
        status
        createdAt
        archivedAt
        customerByCustomerId {
          id
          name
        }
      }
    }
  }
`;

export const ALL_JOBS_WITH_ADDRESSES_QUERY = gql`
  query AllJobsWithAddresses($domainId: Int!) {
    allJobs(condition: { domainId: $domainId }) {
      nodes {
        id
        name
        archivedAt
        addressByAddressId {
          id
          street
          city
          state
          zip
        }
        customerByCustomerId {
          id
          name
          addressesByCustomerId {
            nodes {
              id
              street
              city
              state
              zip
            }
          }
        }
      }
    }
  }
`;

export const JOB_BY_ID_QUERY = gql`
  query JobById($id: Int!) {
    jobById(id: $id) {
      id
      name
      description
      status
      createdAt
      archivedAt
      addressId
      addressByAddressId {
        id
        street
        city
        state
        zip
      }
      customerByCustomerId {
        id
        name
        addressesByCustomerId {
          nodes {
            id
            street
            city
            state
            zip
          }
        }
      }
      draftQuotesByJobId(orderBy: CREATED_AT_DESC) {
        nodes {
          id
          name
          createdAt
          finalizedQuoteId
        }
      }
    }
  }
`;

export const CREATE_JOB_MUTATION = gql`
  mutation CreateJob($domainId: Int!, $customerId: Int!, $name: String!, $description: String, $addressId: Int) {
    createJob(input: { job: { domainId: $domainId, customerId: $customerId, name: $name, description: $description, addressId: $addressId } }) {
      job {
        id
        name
      }
    }
  }
`;

export const ARCHIVE_JOB_MUTATION = gql`
  mutation ArchiveJob($id: Int!, $archivedAt: Datetime) {
    updateJobById(input: { id: $id, jobPatch: { archivedAt: $archivedAt } }) {
      job {
        id
        archivedAt
      }
    }
  }
`;

export const UPDATE_JOB_ADDRESS_MUTATION = gql`
  mutation UpdateJobAddress($id: Int!, $addressId: Int) {
    updateJobById(input: { id: $id, jobPatch: { addressId: $addressId } }) {
      job {
        id
        addressId
      }
    }
  }
`;
